// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SocialWhatsapp = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g transform="translate(1 1)" fill="none" fillRule="evenodd">
			<circle stroke="#1CB39B" cx={20} cy={20} r={20} />
			<path
				d="M24.355 21.99c-.046-.075-.166-.12-.346-.21-.18-.089-1.068-.523-1.234-.582-.165-.06-.286-.09-.406.09-.12.179-.466.582-.572.702-.105.12-.21.134-.39.045-.181-.09-.763-.28-1.452-.889a5.448 5.448 0 0 1-1.005-1.24c-.104-.18-.01-.276.08-.365.08-.081.18-.21.27-.314.09-.105.12-.18.181-.3.06-.119.03-.223-.015-.313-.045-.089-.406-.97-.557-1.33-.15-.357-.3-.298-.406-.298-.105 0-.226-.015-.346-.015a.665.665 0 0 0-.481.224c-.165.18-.631.613-.631 1.494 0 .88.646 1.733.736 1.852.09.12 1.248 1.987 3.084 2.704 1.835.717 1.835.477 2.166.447.33-.029 1.068-.432 1.218-.85.15-.42.15-.778.106-.852m-3.718-7.826c-3.415 0-6.192 2.755-6.192 6.143a6.08 6.08 0 0 0 1.18 3.602l-.774 2.281 2.38-.756a6.19 6.19 0 0 0 3.406 1.016c3.413 0 6.19-2.756 6.19-6.143 0-3.388-2.777-6.143-6.19-6.143M28 20.307c0 4.035-3.297 7.306-7.363 7.306a7.371 7.371 0 0 1-3.56-.909L13 28l1.329-3.92a7.229 7.229 0 0 1-1.056-3.773c0-4.036 3.296-7.307 7.364-7.307C24.703 13 28 16.271 28 20.307"
				fill="#1CB39B"
			/>
		</g>
	</svg>
);
export default SocialWhatsapp;
